import * as p from '@clack/prompts'
import type { BetterstartCommandRuntime } from '@cli-types/core-engine/commands.js'
import type { Command } from 'commander'
import { INIT_COMMAND } from '@cli-constants/commands.js'
import { isInteractiveTerminalSession } from '@cli-utils/terminal.js'
import { findConfigFile } from '@core-engine/config/resolver/find-config-file.js'
import { cancelled } from './cancelled.js'
import { promptInvocation } from './prompt-invocation.js'

/**
 * Non-interactive sessions keep the historical behavior (help on stdout,
 * exit 0) because scripts depend on it.
 */
export async function runDefaultAction(
  program: Command,
  runtime: BetterstartCommandRuntime
): Promise<void> {
  // Requires a TTY on both ends. stdout alone being piped is enough to make a
  // prompt invisible while it still blocks on stdin, so a bare run behind
  // `| cat` or `$(...)` must fall back to help rather than hang the caller.
  if (!isInteractiveTerminalSession()) {
    program.outputHelp()
    return
  }

  const cwd = process.cwd()
  if (!findConfigFile(cwd)) {
    await program.parseAsync([INIT_COMMAND], { from: 'user' })
    return
  }

  const argv = await promptInvocation(program, runtime, cwd)
  if (cancelled(argv)) {
    p.cancel('No command selected.')
    return
  }

  await program.parseAsync(argv, { from: 'user' })
}
